import React from "react";
import guardianTelematics from "../../assets/images/guardian-telematics.png";
import MapContainer from "../Maps/MainMap/MainMap";
import jwt_decode from "jwt-decode";
import GetUser from "../../services/auth.getUser";
import { useEffect, useState } from "react";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { createPoints } from "../../shared/utility";
import axiosConfig from "../../axiosConfig";
import Loading from "../Loading/loading";
import StatisticsGridForHomeAndMap from "../Charts/StatisticsGridHome&Map/StatisticsGridHome&Map";
import AlarmsForHome from "../Alerts/AlarmsForHome";
import Grid from "@material-ui/core/Grid";
import { CardContent } from "@material-ui/core";
import { Card, CardHeader } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import { makeStyles } from "@material-ui/core";
import { Tabs, Tab, Paper } from "@material-ui/core";
import  * as alarms from "../../shared/language.json";
import PropTypes from 'prop-types';
import endPoints from "../../shared/endPoints.json";
import "./Home.css";

function Home(props) {
  const {
    isAuth,
    editMapPoint,
    editMapState,
    municipalityMapState,
    alertForAlertsTable,
    objectForTableFiltering,
  } = props;

  const [alarmInjectedToTable, setalarmInjectedToTable] = useState({});
  const [loading, setLoading] = useState(true);
  const useStyles2 = makeStyles(styles);
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,

      backgroundColor: theme.palette.background.paper,
    },

    tabs: {
      backgroundColor: "#88b8b9",
      color: "white",
      fontWeight: 600,
    },
  }));

  useEffect(() => {
    if (isAuth) {
      const getTheUser = GetUser();
      const decodedToken = jwt_decode(getTheUser.accessToken);
      const municipalityId = decodedToken.municipalityID;
      municipalityMapState(JSON.parse(municipalityId));

      axiosConfig
        .get("/Beneficiary/GetModelForMap")
        .then((res) => {
          let pointsFromDatabase = res.data;
          editMapState(
            {
              pointsStore: createPoints(pointsFromDatabase),
              alertForAlertsTable: [],
            },

            editMapPoint,

            "on"
          );
        })
        .finally(function () {
          setLoading(false);
        });
    }
  }, []);

  /*useEffect(() => {
    return function cleanupSignalR() {
      editMapState(
        {
          pointsStore: null,

          filteredPointsStore: null,
        },

        editMapPoint,

        "off"
      );
    };
  }, []);*/

  useEffect(() => {
    return () =>
      editMapState({
        objectForTableFiltering: {
          beneficiaryId: null,
          alertScore: null,
          statusId:null
        },
      });
  }, []);

  useEffect(() => {
    setalarmInjectedToTable(alertForAlertsTable[0]);
  }, [alertForAlertsTable]);

  const classes = useStyles();
  const classes2 = useStyles2();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const InitializeFilterMap = (event, newValue) =>{
    editMapState({
      objectForTableFiltering: {
        beneficiaryId: null,
        alertScore: null,
        statusId:null
      },
    });
    setValue(newValue);
  }

  if (loading === false) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={8}>
          <div className="home_title">
            Πίνακας Ελέγχου
          </div>
          <Grid item xs={12} sm={12} md={12}>
            <div className="Home_map">
              <Card chart>
                <CardHeader color="warning">
                  <h4 className={classes2.cardTitleWhite}>Χάρτης</h4>
                </CardHeader>
                <CardContent>
                  <MapContainer  handleChange= {handleChange}/>
                </CardContent>
              </Card>
            </div>
          </Grid>
          <Paper className={classes.root}>
            <Tabs
              value={value}
              onChange={InitializeFilterMap}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label={alarms.ALARMLABELS.OPEN}/>
              <Tab label={alarms.ALARMLABELS.ASSIGNED}/>
            </Tabs>
          </Paper>
          <TabPanel value={value} index={0}>
            <AlarmsForHome
              alarmInjected={alarmInjectedToTable}
              objectForTableFiltering={objectForTableFiltering}
              index = {0}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <AlarmsForHome
              alarmInjected={alarmInjectedToTable}
              objectForTableFiltering={objectForTableFiltering}
              index = {1}
            />
          </TabPanel>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <StatisticsGridForHomeAndMap />
        </Grid>
        <Grid item xs={12}>
          <div className="home-footer">
            <div className="home-footer-content">
              <div className="footer-text-block">
                Το έργο υλοποιήθηκε στο πλαίσιο του προγράμματος<br />
                «Ανάπτυξη Ψηφιακών Προϊόντων και Υπηρεσιών» του<br />
                Εθνικού Σχεδίου Ανάκαμψης και Ανθεκτικότητας<br />
                «Ελλάδα2.0» με τη χρηματοδότηση της Ευρωπαϊκής<br />
                Ένωσης-NextGenerationEU<br />
                <a href={endPoints.DIGITALSMELINK} target="_blank" rel="noopener noreferrer">{endPoints.DIGITALSMELINK}</a>
              </div>
              <div className="footer-center">
                <a href="#">Όροι Χρήσης</a>
                <a href="#">Πολιτική Απορρήτου</a>
              </div>
              <div className="footer-right">
                <img src={guardianTelematics} alt="Next Generation Banner" />
              </div>
            </div>
            <div className="footer-bottom">
              Guardian Telematics SA © Copyright 2023. All Rights Reserved
            </div>
          </div>
        </Grid>
      </Grid>
    );
  } else {
    return <Loading></Loading>;
  }
}

function TabPanel(props) {
  const { children, value, index } = props;
  return (<div>{value === index && children}</div>)
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};


const mapStateToProps = (state) => {
  return {
    ...state.auth,

    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapPoint: (mapPointCoordinates, url, mapObject) => {
      dispatch(actions.editMapPointAsync(mapPointCoordinates, url, mapObject));
    },

    editMapState: (mapPayload, editMapPoint, setter) => {
      dispatch(actions.editMapStateAsync(mapPayload))
    },

    municipalityMapState: (id) => {
      dispatch(actions.setMunicipalityId(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
